import React from 'react';
import { Grid } from '@mui/material';

interface IProgressGraphProps {
  children: React.ReactNode;
}

/**
 * Layout wrapper for dashboard graph/chart components (e.g. InvoiceStatusGraph, CreditStatusGraph).
 * Does not know anything about what it wraps - just arranges whatever graphs are passed in as children.
 */
export const ProgressGraph: React.FC<IProgressGraphProps> = ({ children }) => (
  <Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
    {React.Children.map(children, (child) => (
      <Grid item xs={12} md={6}>{child}</Grid>
    ))}
  </Grid>
);
